export default __webpack_public_path__ + "static/media/youtube-clone.f0488ca2.png";